module.exports = __webpack_public_path__ + "static/img/4062_phase_function_Paper_PointsHejduk_Prediction.b710a36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4062_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Aggc
// module chunks = 0